import React, { useState } from 'react'
import styles from './styles.module.scss'
import ByEmailChip from './ByEmailChip'
import ByFileUpload from './ByFileUpload'
import InviteButton from '../InviteButton'
import { useDispatch } from 'react-redux'
import { TextArea } from 'srcReact/components/common2/TextArea'
import { useTranslation } from 'react-i18next'
import { inviteActions } from '../../actions'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import RadioButtonGroup from 'srcReact/components/common2/RadioButtonGroup'

function InviteByEmail({ type, id, workplaceId, isMobile, callbackSuccessFun, callbackFailureFun }) {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const [emails, setEmails] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [hasEmailErrors, setHasEmailErrors] = useState(true)
  const [selectedInviteType, setSelectedInviteType] = useState('manual')
  const inviteTypes = [
    { value: 'manual', label: t('invite_group_mixr.byEmail.manual') },
    { value: 'csv', label: 'CSV' }
  ]
  const [message, setMessage] = useState({
    name: 'message',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: false
  })

  const sendInvites = () => {
    const strEmails = emails.map((e) => e.email || e).join(',')
    if (type === 'workplace') {
      if (strEmails?.length > 0) {
        dispatch(
          inviteActions.inviteToWorkplace(workplaceId, strEmails, message.value, callbackSuccessFun, callbackFailureFun)
        )
        setErrorMessage('')
      } else {
        setErrorMessage(t('invite_group_mixr.byEmail.fileUpload.no_email_found'))
      }
    } else {
      if (strEmails?.length > 0) {
        dispatch(inviteActions.sendInvitesToNonWPMembers(id, type, strEmails, message.value, callbackSuccessFun))
        setErrorMessage('')
      } else {
        setErrorMessage(t('invite_group_mixr.byEmail.fileUpload.no_email_found'))
      }
    }
  }

  const handleInviteTypeChange = (e) => {
    const value = e.target.value
    setSelectedInviteType(value)
  }

  return (
    <div className={styles.byEmailContainer}>
      <div className={styles.inputEmailsContainer}>
        <RadioButtonGroup
          label={t('invite_group_mixr.byEmail.radioLabel')}
          items={inviteTypes}
          selectedItemValue={selectedInviteType}
          onChange={handleInviteTypeChange}
          radioContainerCSS={styles.radioContainerCSS}
        />
        <div className={styles.inviteWithMessageContainer}>
          {selectedInviteType === 'manual' ? (
            <ByEmailChip
              workplaceId={workplaceId}
              isMobile={isMobile}
              className={styles.inviteByChip}
              setEmails={setEmails}
              setHasEmailErrors={setHasEmailErrors}
            />
          ) : (
            <ByFileUpload className={styles.inviteByFile} setEmails={setEmails} setHasEmailErrors={setHasEmailErrors} />
          )}

          <TextArea
            rows={8}
            isRequired={false}
            fieldInfo={message}
            label={t('popinFinalizeInvitations.message')}
            onChange={(e) => setMessage({ ...message, value: e.target.value })}
            customWrapperCss={styles.message}
            placeholder={t('global.placeholder')}
          />
        </div>
      </div>
      {errorMessage && <ErrorMessage className={styles.errorMessage} text={errorMessage} />}
      <InviteButton
        inviteType='email'
        inviteCount={emails.length}
        className={styles.inviteBtn}
        disabled={hasEmailErrors}
        onClick={sendInvites}
      />
    </div>
  )
}

export default InviteByEmail
